<div
  *ngIf="visible"
  @slideFade
  class="announcement-container"
>
  <div class="announcement-content">
    <div class="icon"><mat-icon color="primary">campaign</mat-icon></div>

    <div class="text">
      <h4>{{ title }}</h4>
      <p>
        {{ message }}
      </p>
    </div>

    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
